var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isloading),expression:"isloading"}],staticClass:"loading"},[_c('span',[_vm._v("可能会加载时间有点长，请耐心等待...")])]),_vm._v(" "),_c('iframe',{ref:"viframe",staticStyle:{"width":"100%","height":"800px","border":"none"},attrs:{"src":_vm.pdfUrl}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5317ca3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/components/vword.vue
// module id = null
// module chunks = 